module.exports = __webpack_public_path__ + "static/media/team-building.3d64d72d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/team-building.jpg
// module id = 510
// module chunks = 0